module.exports = __webpack_public_path__ + "img/user101.a13fed4f.jpg";